/* eslint-disable */
import { IMAGE_TYPE, INPUT_IMAGE_TYPE, TRYON_CLOTH_TYPE, CLOTH_COLOR_TYPE } from "./CONST";

const imageBaseUrlV3 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/";
const servicepageBaseUrlV3 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/servicepage/";

export default {
    [IMAGE_TYPE.MODEL]: [{
        inputImage: imageBaseUrlV3 + "model1_0822.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d7135f9f-f332-4b81-a4aa-68b4d2f142cb",
        inputImageColorMaskId: "9d391917-e531-4bc4-8167-3d75d1258b67",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_654f74d789244b22929025cc484fa3e7.png",
            foregroundAlphaMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_8ad0bc7221e940918e2704b9e9aec49f.png",
            foregroundMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_b9cb29187fff48f5a2e8d9f276274bd9.png"
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:76a47a3c-00ce-4756-88c1-1be0c952ea78",
        inputImageColorMaskId: "9e3fa53a-c304-4787-a5c5-bac0a4d87b43",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-cBJHxsGITNi7-858966353-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:91c8584a-c9f5-40c9-a908-6add07e8c19c",
        inputImageColorMaskId: "a0280cc8-0ae0-48b8-948f-907655e12b5f",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-XwDHrJaGQpqz-464695105-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['男']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5e15b3b8-7466-4397-8e81-4184ba75116c",
        inputImageColorMaskId: "0419dc37-d2ab-4329-a61c-2a8a9b79fc13",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-c2oXiEP7WYIU-827365598-0.jpg",
        },
        resourceFilter: {
            age: ['大童'],
            sex: ['女']
        }
    }],
    [IMAGE_TYPE.BACKGROUND]: [{
        inputImage: imageBaseUrlV3 + "model1_0822.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d7135f9f-f332-4b81-a4aa-68b4d2f142cb",
        inputImageColorMaskId: "9d391917-e531-4bc4-8167-3d75d1258b67",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_654f74d789244b22929025cc484fa3e7.png",
            foregroundAlphaMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_8ad0bc7221e940918e2704b9e9aec49f.png",
            foregroundMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_b9cb29187fff48f5a2e8d9f276274bd9.png"
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:76a47a3c-00ce-4756-88c1-1be0c952ea78",
        inputImageColorMaskId: "9e3fa53a-c304-4787-a5c5-bac0a4d87b43",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-cBJHxsGITNi7-858966353-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:91c8584a-c9f5-40c9-a908-6add07e8c19c",
        inputImageColorMaskId: "a0280cc8-0ae0-48b8-948f-907655e12b5f",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-XwDHrJaGQpqz-464695105-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['男']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5e15b3b8-7466-4397-8e81-4184ba75116c",
        inputImageColorMaskId: "0419dc37-d2ab-4329-a61c-2a8a9b79fc13",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-c2oXiEP7WYIU-827365598-0.jpg",
        },
        resourceFilter: {
            age: ['大童'],
            sex: ['女']
        }
    }],
    [IMAGE_TYPE.POSE_TRYON]: [{
        inputImage: imageBaseUrlV3 + "model1_0822.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d7135f9f-f332-4b81-a4aa-68b4d2f142cb",
        inputImageColorMaskId: "9d391917-e531-4bc4-8167-3d75d1258b67",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_654f74d789244b22929025cc484fa3e7.png",
            foregroundAlphaMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_8ad0bc7221e940918e2704b9e9aec49f.png",
            foregroundMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_b9cb29187fff48f5a2e8d9f276274bd9.png"
        },
        resourceFilter: {
            age: ['成年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:76a47a3c-00ce-4756-88c1-1be0c952ea78",
        inputImageColorMaskId: "9e3fa53a-c304-4787-a5c5-bac0a4d87b43",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-cBJHxsGITNi7-858966353-0.jpg",
        },
        resourceFilter: {
            age: ['成年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:91c8584a-c9f5-40c9-a908-6add07e8c19c",
        inputImageColorMaskId: "a0280cc8-0ae0-48b8-948f-907655e12b5f",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-XwDHrJaGQpqz-464695105-0.jpg",
        },
        resourceFilter: {
            age: ['成年'],
            sex: ['男']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5e15b3b8-7466-4397-8e81-4184ba75116c",
        inputImageColorMaskId: "0419dc37-d2ab-4329-a61c-2a8a9b79fc13",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-c2oXiEP7WYIU-827365598-0.jpg",
        },
        resourceFilter: {
            age: ['儿童'],
            sex: ['女']
        }
    }],
    [IMAGE_TYPE.GLASSES_TRYON]: [{
        inputImage: imageBaseUrlV3 + "glasses_sample1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:15d6788f-4d5b-4c2b-b13b-94dbb76597ee",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-KlFdXCzsHYGJ596cc5d80abc468eb5e2b4e81ec523ef-8016727-id-1.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-KlFdXCzsHYGJ596cc5d80abc468eb5e2b4e81ec523ef-8016727-id-2.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-KlFdXCzsHYGJ596cc5d80abc468eb5e2b4e81ec523ef-8016727-id-3.png"
        }
    }, {
        inputImage: imageBaseUrlV3 + "glasses_sample2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:202cc69a-4cf5-4946-8a32-7ab763c45ecf",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-76Bu95TVrvS1993a0692f8834f31a79a8e2e2b7eefd5-1729972274-id-1.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-76Bu95TVrvS1993a0692f8834f31a79a8e2e2b7eefd5-1729972274-id-2.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-76Bu95TVrvS1993a0692f8834f31a79a8e2e2b7eefd5-1729972274-id-3.png"
        }
    }, {
        inputImage: imageBaseUrlV3 + "glasses_sample3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:a0d6f5d4-37d3-47b3-bd96-8be80b906b26",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-R5s2wlchXiqU8f42f089ec0a43bc8e9a3d4b41a889e6-4156627166-id-1.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-R5s2wlchXiqU8f42f089ec0a43bc8e9a3d4b41a889e6-4156627166-id-2.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-R5s2wlchXiqU8f42f089ec0a43bc8e9a3d4b41a889e6-4156627166-id-3.png"
        }
    }, {
        inputImage: imageBaseUrlV3 + "glasses_sample4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:a89b1f20-2a54-479a-8aa2-ca26fabb0775",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-sI9FNJelQruy3492f41d5fb143cfba7ffea55d38d0bd-10790738-id-1.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-sI9FNJelQruy3492f41d5fb143cfba7ffea55d38d0bd-10790738-id-2.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-sI9FNJelQruy3492f41d5fb143cfba7ffea55d38d0bd-10790738-id-3.png"
        }
    }],
    [IMAGE_TYPE.NECKLACE_TRYON]: [{
        inputImage: imageBaseUrlV3 + "necklace_sample1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
    }, {
        inputImage: imageBaseUrlV3 + "necklace_sample2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
    }, {
        inputImage: imageBaseUrlV3 + "necklace_sample3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
    }, {
        inputImage: imageBaseUrlV3 + "necklace_sample4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
    }],
    [IMAGE_TYPE.SIM_TRYON]: [{
        inputImage: imageBaseUrlV3 + "tryon1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:79bf3c92-5aeb-4b93-bdb5-249737c7f1dd",
        inputImageClothType: TRYON_CLOTH_TYPE.TOP,
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:b59ba734-7fd3-4998-b57c-41306e6311cf",
        inputImageClothType: TRYON_CLOTH_TYPE.DRESS,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:98d4321c-8e24-4709-b0fb-d309c2b3e210",
        inputImageClothType: TRYON_CLOTH_TYPE.TOP,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:acb4e86f-62f4-4f67-be13-0d4c3732d908",
        inputImageClothType: TRYON_CLOTH_TYPE.BOTTOM,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
        },
    }],
    [IMAGE_TYPE.FLATLAY3D]: [{
        inputImage: imageBaseUrlV3 + "tryon1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:79bf3c92-5aeb-4b93-bdb5-249737c7f1dd",
        inputImageClothType: TRYON_CLOTH_TYPE.TOP,
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:b59ba734-7fd3-4998-b57c-41306e6311cf",
        inputImageClothType: TRYON_CLOTH_TYPE.DRESS,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:98d4321c-8e24-4709-b0fb-d309c2b3e210",
        inputImageClothType: TRYON_CLOTH_TYPE.TOP,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "tryon4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aicloth_mask:acb4e86f-62f4-4f67-be13-0d4c3732d908",
        inputImageClothType: TRYON_CLOTH_TYPE.BOTTOM,
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
        },
    }],
    [IMAGE_TYPE.CLOTHES]: {
        [INPUT_IMAGE_TYPE.MULTI]: [{
            topInputImage: imageBaseUrlV3 + "tryon_set_1.1.png",
            topInputImageWidth: 1440,
            topInputImageHeight: 1920,
            topInputImageMaskId: "aicloth_mask:1ba1aad8-efc0-4f2c-acc4-ebf59fa0dbea",
            topInputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-l5yjFsY9vqwE-6486816-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-l5yjFsY9vqwE-6486816-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-l5yjFsY9vqwE-6486816-0.png",
            },
            bottomInputImage: imageBaseUrlV3 + "tryon_set_1.2.png",
            bottomInputImageWidth: 1440,
            bottomInputImageHeight: 1920,
            bottomInputImageMaskId: "aicloth_mask:14e45d13-845b-4ba3-9849-4e37320ffce6",
            bottomInputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-LCqXwzQE3Gmi-183063482-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-LCqXwzQE3Gmi-183063482-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-LCqXwzQE3Gmi-183063482-0.png",
            }
        }, {
            topInputImage: imageBaseUrlV3 + "tryon_set_2.1.png",
            topInputImageWidth: 1440,
            topInputImageHeight: 1920,
            topInputImageMaskId: "aicloth_mask:0d91b70f-34ba-4493-bfe4-3b6d23acde70",
            topInputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-js2wxD63n9iR-1421509370-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-js2wxD63n9iR-1421509370-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-js2wxD63n9iR-1421509370-0.png",
            },
            bottomInputImage: imageBaseUrlV3 + "tryon_set_2.2.png",
            bottomInputImageWidth: 1440,
            bottomInputImageHeight: 1920,
            bottomInputImageMaskId: "aicloth_mask:658caa3e-e30d-4580-9702-cb651eaa728d",
            bottomInputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-fRlj9W6Jqaz7-1113756305-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-fRlj9W6Jqaz7-1113756305-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-fRlj9W6Jqaz7-1113756305-0.png",
            }
        }],
        [INPUT_IMAGE_TYPE.SINGLE]: [{
            inputImage: imageBaseUrlV3 + "tryon1.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aicloth_mask:79bf3c92-5aeb-4b93-bdb5-249737c7f1dd",
            inputImageClothType: TRYON_CLOTH_TYPE.TOP,
            inputImageOriginalMask: {
                "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
                "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png",
                "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-Sjq5Cc7KxWzH-942134504-0.png"
            },
        }, {
            inputImage: imageBaseUrlV3 + "tryon2.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aicloth_mask:b59ba734-7fd3-4998-b57c-41306e6311cf",
            inputImageClothType: TRYON_CLOTH_TYPE.DRESS,
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-yQJZVr2Ajg9w-519066949-0.png",
            },
        }, {
            inputImage: imageBaseUrlV3 + "tryon3.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aicloth_mask:98d4321c-8e24-4709-b0fb-d309c2b3e210",
            inputImageClothType: TRYON_CLOTH_TYPE.TOP,
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-oId0xnrYEtus-2019549397-0.png",
            },
        }, {
            inputImage: imageBaseUrlV3 + "tryon4.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aicloth_mask:acb4e86f-62f4-4f67-be13-0d4c3732d908",
            inputImageClothType: TRYON_CLOTH_TYPE.BOTTOM,
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-clothseg-cloth-cloth_mask5000-TIjySCh2mRMc-249777506-0.png",
            },
        }],
    },
    [IMAGE_TYPE.SHOES]: {
        [INPUT_IMAGE_TYPE.MULTI]: [{
            inputImage: imageBaseUrlV3 + "shoe_set_1.1.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:279d8047-5d5d-4592-a363-1777c8bfbefc",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-ILOHJ9lNXfZb0f09b6d7f150490ba6442161a4a6b528-4139583366-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-ILOHJ9lNXfZb0f09b6d7f150490ba6442161a4a6b528-4139583366-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-ILOHJ9lNXfZb0f09b6d7f150490ba6442161a4a6b528-4139583366-id-3.png",
            },
            no1MultiAngleImage: imageBaseUrlV3 + "shoe_set_1.2.png",
            no1MultiAngleImageWidth: 1440,
            no1MultiAngleImageHeight: 1920,
            no1MultiAngleImageMaskId: "aishoes_mask:9b9446c2-1bcf-49f8-959d-f4492ebac9b2",
            no1MultiAngleImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-9Nifpsn5Pq3J383a81d38e9543e79ffe3a85314e9411-2900998290-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-9Nifpsn5Pq3J383a81d38e9543e79ffe3a85314e9411-2900998290-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-9Nifpsn5Pq3J383a81d38e9543e79ffe3a85314e9411-2900998290-id-3.png",
            },
            no2MultiAngleImage: imageBaseUrlV3 + "shoe_set_1.3.png",
            no2MultiAngleImageWidth: 1440,
            no2MultiAngleImageHeight: 1920,
            no2MultiAngleImageMaskId: "aishoes_mask:af095e50-cc44-4efc-9820-d181c14b810a",
            no2MultiAngleImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-7MKEQzkVWDSO6be89365d2754f7dabba4ff41d3c50d7-3022323641-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-7MKEQzkVWDSO6be89365d2754f7dabba4ff41d3c50d7-3022323641-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-7MKEQzkVWDSO6be89365d2754f7dabba4ff41d3c50d7-3022323641-id-3.png",
            }
        }, {
            inputImage: imageBaseUrlV3 + "shoe_set_2.1.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:0c8fe8db-f7a8-4623-ac9e-2db8f595f868",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-rN1fgnIoKx39f80192d081364b1ba2bb9bfd221e79aa-2260609770-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-rN1fgnIoKx39f80192d081364b1ba2bb9bfd221e79aa-2260609770-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-rN1fgnIoKx39f80192d081364b1ba2bb9bfd221e79aa-2260609770-id-3.png",
            },
            no1MultiAngleImage: imageBaseUrlV3 + "shoe_set_2.2.png",
            no1MultiAngleImageWidth: 1440,
            no1MultiAngleImageHeight: 1920,
            no1MultiAngleImageMaskId: "aishoes_mask:0142f8f7-f1e2-476f-9fbe-ed5f61ee9a38",
            no1MultiAngleImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-Xt4xufTK6QJOf249d45c2af940aba2cad273a3d362b7-1354940635-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-Xt4xufTK6QJOf249d45c2af940aba2cad273a3d362b7-1354940635-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-Xt4xufTK6QJOf249d45c2af940aba2cad273a3d362b7-1354940635-id-3.png",
            },
            no2MultiAngleImage: imageBaseUrlV3 + "shoe_set_2.3.png",
            no2MultiAngleImageWidth: 1440,
            no2MultiAngleImageHeight: 1920,
            no2MultiAngleImageMaskId: "aishoes_mask:635c552e-d9a1-4425-9309-aa712b833ca8",
            no2MultiAngleImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-ofmVGkHxqOZudfe0571cd6e1485bbaed5379cf2e34c2-2168667563-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-ofmVGkHxqOZudfe0571cd6e1485bbaed5379cf2e34c2-2168667563-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-ofmVGkHxqOZudfe0571cd6e1485bbaed5379cf2e34c2-2168667563-id-3.png",
            }
        }],
        [INPUT_IMAGE_TYPE.SINGLE]: [{
            inputImage: imageBaseUrlV3 + "shoe1.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:15332cee-f34c-4e70-8593-ed2e10070b79",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-ePt8vNfzgSwK9e4193db709445e48ac1802e22c611ba-2151472690-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-ePt8vNfzgSwK9e4193db709445e48ac1802e22c611ba-2151472690-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-ePt8vNfzgSwK9e4193db709445e48ac1802e22c611ba-2151472690-id-3.png",
            },
        }, {
            inputImage: imageBaseUrlV3 + "shoe2.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:58947fe8-7e47-49b9-b43c-2c5c2acbbfbe",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-PsZmUuDeG8R9033e24ffa5674b53b0601a98c92a9512-3214818082-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-PsZmUuDeG8R9033e24ffa5674b53b0601a98c92a9512-3214818082-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-PsZmUuDeG8R9033e24ffa5674b53b0601a98c92a9512-3214818082-id-3.png",
            },
        }, {
            inputImage: imageBaseUrlV3 + "shoe3.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:7f0f88e2-9dd2-4279-a5a5-7f1c4647fc15",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-xiDoNjcEV5gM773877be62014e078d1685e910490406-135127094-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-xiDoNjcEV5gM773877be62014e078d1685e910490406-135127094-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-xiDoNjcEV5gM773877be62014e078d1685e910490406-135127094-id-3.png",
            },
        }, {
            inputImage: imageBaseUrlV3 + "shoe4.png",
            inputImageWidth: 1440,
            inputImageHeight: 1920,
            inputImageMaskId: "aishoes_mask:37911f05-4966-4a02-9a21-09e21ceb3eee",
            inputImageOriginalMask: {
                foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-9P3CBkXh0xUw474a4af818354f7389624dea82ead607-3903471205-id-1.png",
                binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-9P3CBkXh0xUw474a4af818354f7389624dea82ead607-3903471205-id-2.png",
                foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-9P3CBkXh0xUw474a4af818354f7389624dea82ead607-3903471205-id-3.png",
            },
        }]
    },
    [IMAGE_TYPE.MODEL_VIDEO]: [{
        inputImage: imageBaseUrlV3 + "video1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:57988d09-1469-4b46-ae89-81d4b24e1ff7",
    }, {
        inputImage: imageBaseUrlV3 + "video2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5a74ed55-370c-45f9-8be6-d852f0a64a4b",
    }, {
        inputImage: imageBaseUrlV3 + "video3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d2742925-a27e-4a76-94db-3401c33798f9",
    }, {
        inputImage: imageBaseUrlV3 + "video4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:0d571a83-a4ff-4c8b-834b-fc7fe60fe022",
    }],
    [IMAGE_TYPE.IMAGE_TO_VIDEO]: [{
        inputImage: imageBaseUrlV3 + "video1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:57988d09-1469-4b46-ae89-81d4b24e1ff7",
    }, {
        inputImage: imageBaseUrlV3 + "video2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5a74ed55-370c-45f9-8be6-d852f0a64a4b",
    }, {
        inputImage: imageBaseUrlV3 + "video3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d2742925-a27e-4a76-94db-3401c33798f9",
    }, {
        inputImage: imageBaseUrlV3 + "video4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:0d571a83-a4ff-4c8b-834b-fc7fe60fe022",
    }],
    [IMAGE_TYPE.COMMODITY]: [{
        inputImage: imageBaseUrlV3 + "object1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aigoods_mask:df2a7bdb-b8ad-454d-b667-05cde75c4c23",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_alpha-8PHSkDcXnrtG-244247499-1.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-imgobj_cropped-8PHSkDcXnrtG-982148599-2.png",
            "trimmedMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_cropped-8PHSkDcXnrtG-1589822532-3.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-orimask-8PHSkDcXnrtG-1099522057-4.png",
        },
        resourceFilter: {
            recommendCommodityType: "鞋靴箱包"
        }
    }, {
        inputImage: imageBaseUrlV3 + "object2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aigoods_mask:668d96cc-c2c5-44e9-9d4a-acc4bc460ab4",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_alpha-YUgejJ0SOhMm-1170079730-1.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-imgobj_cropped-YUgejJ0SOhMm-1023642195-2.png",
            "trimmedMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_cropped-YUgejJ0SOhMm-1860056989-3.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-orimask-YUgejJ0SOhMm-1269716612-4.png",
        },
        resourceFilter: {
            recommendCommodityType: "美妆个护"
        }
    }, {
        inputImage: imageBaseUrlV3 + "object3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aigoods_mask:a390d7e3-b71a-4372-af02-b9ddb9b4af8e",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_alpha-hRsSwXtpFuWV-1350588222-1.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-imgobj_cropped-hRsSwXtpFuWV-1441344309-2.png",
            "trimmedMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_cropped-hRsSwXtpFuWV-158044054-3.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-orimask-hRsSwXtpFuWV-195510258-4.png",
        },
        resourceFilter: {
            recommendCommodityType: "服饰内衣"
        }
    }, {
        inputImage: imageBaseUrlV3 + "object4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aigoods_mask:e7cfc745-f9f0-47e1-b0ad-32a6402a357f",
        inputImageOriginalMask: {
            "foregroundAlphaMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_alpha-uSb4iDqYKxlX-1852183699-1.png",
            "foregroundMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-imgobj_cropped-uSb4iDqYKxlX-1367997337-2.png",
            "trimmedMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-mask_cropped-uSb4iDqYKxlX-1815165970-3.png",
            "binaryMask": "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-salient_seg5000-orimask-uSb4iDqYKxlX-1761029464-4.png",
        },
        resourceFilter: {
            recommendCommodityType: "母婴文教"
        }
    }],
    [IMAGE_TYPE.COMMODITYRECOLOR]: [{
        inputImage: imageBaseUrlV3 + "color1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:11446569-097a-4149-a313-d4b67aa91179",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-3.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "color2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:49393cff-b36e-4c12-b549-3b4b36854281",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-DFq5pLTCfleI0a741e1189f5476296741cb07ec87d0f-3987662094-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-DFq5pLTCfleI0a741e1189f5476296741cb07ec87d0f-3987662094-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-DFq5pLTCfleI0a741e1189f5476296741cb07ec87d0f-3987662094-id-3.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "color3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:38916105-7724-4079-8576-0371ff97a2b0",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-7vzMVgDGQRYN83b9bf21868f4549aed96449442bf52f-542422215-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-7vzMVgDGQRYN83b9bf21868f4549aed96449442bf52f-542422215-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-7vzMVgDGQRYN83b9bf21868f4549aed96449442bf52f-542422215-id-3.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "color4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:0fd7ad92-9594-4e47-943b-46fbab41e125",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-hLfnPmRZ8B0k7baf4e70212b49b391b14ce6b99f9a1a-3257269840-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-hLfnPmRZ8B0k7baf4e70212b49b391b14ce6b99f9a1a-3257269840-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-hLfnPmRZ8B0k7baf4e70212b49b391b14ce6b99f9a1a-3257269840-id-3.png",
        },
    }],
    [IMAGE_TYPE.CLOTH_RECOLOR]: [{
        inputImage: imageBaseUrlV3 + "color1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:11446569-097a-4149-a313-d4b67aa91179",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-4XfLgj2kAIs7e4ee15f36bb44e0fa85ac2b4bb7d7e1d-3161339269-id-3.png",
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor1.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aishoes_mask:f6047e08-1370-4390-9c24-fe929f65c03e",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fullbody-alpha-cRK4YmsDeP1p003c4367e92b4a548d743ae01fbff909-346347365-id-1.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-mask-cRK4YmsDeP1p003c4367e92b4a548d743ae01fbff909-346347365-id-2.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-shoesseg-fg-cRK4YmsDeP1p003c4367e92b4a548d743ae01fbff909-346347365-id-3.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:5c6df05d-4920-4b83-9801-4eacd8d5ecb8",
        inputImageMultiSemanticId: "5c6df05d-4920-4b83-9801-4eacd8d5ecb8",
        clothReColorIsPerson: true,
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-8e9oywYPQlzR-929792625-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_ae5a10113f3042c9937b78b7b78851ec.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_52338a240ff14aca9ec8b58a53a85bc8.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:3cecb2fc-0d45-4f2e-ba7b-e3db7591105f",
        inputImageMultiSemanticId: "3cecb2fc-0d45-4f2e-ba7b-e3db7591105f",
        clothReColorIsPerson: true,
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-kljw3Dqz9Q0F-1030641676-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_279cf73248d040a7a2c4d3e7ced16745.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_119578a6521e40f6b0f5d9b99ea19167.png"
        },
    }],
    [CLOTH_COLOR_TYPE.SIM_RECOLOR]: [{
        inputImage: imageBaseUrlV3 + "clothRecolor2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:5c6df05d-4920-4b83-9801-4eacd8d5ecb8",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-8e9oywYPQlzR-929792625-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_ae5a10113f3042c9937b78b7b78851ec.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_52338a240ff14aca9ec8b58a53a85bc8.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:3cecb2fc-0d45-4f2e-ba7b-e3db7591105f",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-kljw3Dqz9Q0F-1030641676-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_279cf73248d040a7a2c4d3e7ced16745.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_119578a6521e40f6b0f5d9b99ea19167.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:d8a6065e-ab9a-4c0f-9841-d363afa37601",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-7uMigYnKWsmy-845324902-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_2edbbb5c47874284be040171ed798105.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_2e9dbd0e97b94c0f9059b060bbac9a01.png"
        },
    }, {
        inputImage: imageBaseUrlV3 + "clothRecolor5.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "semantic_cloth_mask:f31cf553-fb99-468a-9aac-78484826de18",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-mutisemantic-mask5000-BLCxWu3Knr1w-474119297-14.png",
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_372f32de6f414d1383c7de6bf148d236.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/temp/2025-12-16/upload_b1c5c2a66c3149a1b90124b7adea8174.png"
        },
    }],
    [IMAGE_TYPE.GRASS_PLANT]: [{
        inputImage: imageBaseUrlV3 + "model1_0822.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:d7135f9f-f332-4b81-a4aa-68b4d2f142cb",
        inputImageColorMaskId: "9d391917-e531-4bc4-8167-3d75d1258b67",
        inputImageOriginalMask: {
            binaryMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_654f74d789244b22929025cc484fa3e7.png",
            foregroundAlphaMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_8ad0bc7221e940918e2704b9e9aec49f.png",
            foregroundMask: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-03-05/upload_b9cb29187fff48f5a2e8d9f276274bd9.png"
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model2.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:76a47a3c-00ce-4756-88c1-1be0c952ea78",
        inputImageColorMaskId: "9e3fa53a-c304-4787-a5c5-bac0a4d87b43",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-cBJHxsGITNi7-858966353-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-cBJHxsGITNi7-858966353-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['女']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model3.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:91c8584a-c9f5-40c9-a908-6add07e8c19c",
        inputImageColorMaskId: "a0280cc8-0ae0-48b8-948f-907655e12b5f",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-XwDHrJaGQpqz-464695105-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-XwDHrJaGQpqz-464695105-0.jpg",
        },
        resourceFilter: {
            age: ['青年'],
            sex: ['男']
        }
    }, {
        inputImage: imageBaseUrlV3 + "model4.png",
        inputImageWidth: 1440,
        inputImageHeight: 1920,
        inputImageMaskId: "aimodel_mask:5e15b3b8-7466-4397-8e81-4184ba75116c",
        inputImageColorMaskId: "0419dc37-d2ab-4329-a61c-2a8a9b79fc13",
        inputImageOriginalMask: {
            foregroundAlphaMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-mask-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            foregroundMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-fullbody-alpha-seg_realperson5000-c2oXiEP7WYIU-827365598-0.png",
            binaryMask: "https://photostudio-ai-oss.arcsoft.com.cn/aigc/upload/out-filter-cloth-full-seg_realperson5000-c2oXiEP7WYIU-827365598-0.jpg",
        },
        resourceFilter: {
            age: ['大童'],
            sex: ['女']
        }
    }],
    [IMAGE_TYPE.WATERMARK_REMOVE]: [{
        inputImage: servicepageBaseUrlV3 + "sample110.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "sample111.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "sample112.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "sample113.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "sample114.png",
    }],
    [IMAGE_TYPE.SMART_DETAILA_PAGE]: [{
        inputImage: servicepageBaseUrlV3 + "smartDetailPage_1.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "smartDetailPage_2.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "smartDetailPage_3.png",
    }, {
        inputImage: servicepageBaseUrlV3 + "smartDetailPage_4.png",
    }],
}
